import { toSuccess, toReset } from 'react-async-client';
import { pick } from 'ramda';

import {
    GET_PROJECT_LIST,
    SET_PROJECT_LIST_PAGINATION,
    SET_PROJECT_LIST_FILTERS,

    GET_WORKSHEET_LIST,
    SET_WORKSHEET_LIST_PAGINATION,
    SET_WORKSHEET_LIST_FILTERS,

    GET_REQUEST_LIST,
    SET_REQUEST_LIST_PAGINATION,

    GET_APPROVAL_PERSON_LIST,
    SET_APPROVAL_PERSON_LIST_PAGINATION,

    GET_APPROVAL_PROJECT_LIST,
    SET_APPROVAL_PROJECT_LIST_PAGINATION,

    GET_PROJECT_MASS_LIST,
    SET_PROJECT_MASS_LIST_FILTERS,
    SET_PROJECT_MASS_LIST_PAGINATION,

    GET_WORKSHEET_MASS_LIST,
    SET_WORKSHEET_MASS_LIST_FILTERS,
    SET_WORKSHEET_MASS_LIST_PAGINATION,

    GET_NOTDONE_LIST,
    SET_NOTDONE_LIST_PAGINATION,
} from 'constants/actionTypes';
import { defaultPagination } from 'constants/defaults';

const getPaginationFromResponse = pick(['line', 'linesLeft', 'linesPerPage', 'linesTotal']);

const createPaginationReducer = (GET_DATA, SET_FILTERS, SET_PAGINATION) =>
    (state = defaultPagination, action) => {
        switch(action.type) {
            case toSuccess(GET_DATA):
                return {
                    ...getPaginationFromResponse(action.payload),
                    page: state.page,
                };
            case toReset(GET_DATA):
            case SET_FILTERS:
                return defaultPagination;
            case SET_PAGINATION:
                return {
                    ...state,
                    line: action.payload * state.linesPerPage - state.linesPerPage,
                    page: action.payload,
                    linesPerPage: action.attrs || state.linesPerPage,
                };
            default:
                return state;
        }
    };

export const projectListPaginationReducer = createPaginationReducer(
    GET_PROJECT_LIST,
    SET_PROJECT_LIST_FILTERS,
    SET_PROJECT_LIST_PAGINATION
);

export const worksheetListPaginationReducer = createPaginationReducer(
    GET_WORKSHEET_LIST,
    SET_WORKSHEET_LIST_FILTERS,
    SET_WORKSHEET_LIST_PAGINATION
);

export const requestListPaginationReducer = createPaginationReducer(
    GET_REQUEST_LIST,
    null,
    SET_REQUEST_LIST_PAGINATION
);

export const approvalPersonListReducer = createPaginationReducer(
    GET_APPROVAL_PERSON_LIST,
    null,
    SET_APPROVAL_PERSON_LIST_PAGINATION
);

export const approvalProjectListReducer = createPaginationReducer(
    GET_APPROVAL_PROJECT_LIST,
    null,
    SET_APPROVAL_PROJECT_LIST_PAGINATION
);

export const projectMassListPaginationReducer = createPaginationReducer(
    GET_PROJECT_MASS_LIST,
    SET_PROJECT_MASS_LIST_FILTERS,
    SET_PROJECT_MASS_LIST_PAGINATION
);

export const worksheetMassListPaginationReducer = createPaginationReducer(
    GET_WORKSHEET_MASS_LIST,
    SET_WORKSHEET_MASS_LIST_FILTERS,
    SET_WORKSHEET_MASS_LIST_PAGINATION
);

export const notDoneListPaginationReducer = createPaginationReducer(
    GET_NOTDONE_LIST,
    null,
    SET_NOTDONE_LIST_PAGINATION,
);
